import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { VisuallyHidden } from '@calendly/ui/components/visually-hidden'

import { readAsBase64 } from './certificate'

export const CertificateFileInput = ({ name }) => {
  const { setFieldValue } = useFormContext()

  const handleCertSelect = (e) => {
    const file = e.target.files[0]
    e.target.value = ''

    readAsBase64(file)
      .then((result) => setFieldValue(name, result))
      .catch(() => setFieldValue(name, ''))
  }

  return (
    <Button as="label" decoration="secondary-outline" size="small">
      <VisuallyHidden
        as="input"
        type="file"
        name="certificateFile"
        accept=".pem,.der,.cer,.crt,.cert"
        onChange={handleCertSelect}
      />
      {I18n.t(
        'publisher.organization_settings.sso.idp_information.certificate_upload'
      )}
    </Button>
  )
}
